import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'

import CallToActionDecorator from 'decorators/cta/cta_decorator'
import styles from './text_link.scss'

const color = {
	blue: 'font-blue',
	green: 'font-green',
	yellow: 'font-yellow',
	red: 'font-red',
	white: 'font-white',
	grey: 'font-grey',
	lightRed: 'font-light-red',
}

const weight = {
	light: 'font-light',
	medium: 'font-medium',
	bold: 'font-bold',
}

class TextLink extends PureComponent {

	render() {
		return (
			<span
				tabIndex={this.props.tabIndex}
				styleName={classNames({
					text_link: true,
					pointer_cursor: this.props.href || this.props.onClick,
					[color[this.props.color]]: true,
					[weight[this.props.weight]]: true,
					ellipsis: this.props.useEllipsis,
					underlined: this.props.isUnderlined,
					italic: this.props.italic,
				})}
			>
				{this.props.children}
			</span>
		)
	}
}

TextLink.propTypes = {
	children: PropTypes.node,
	tabIndex: PropTypes.number,
	color: PropTypes.string,
	weight: PropTypes.string,
	useEllipsis: PropTypes.bool,
	isUnderlined: PropTypes.bool,
	italic: PropTypes.bool,
}

TextLink.defaultProps = {
	tabIndex: 0,
	color: 'blue',
	weight: 'light',
	useEllipsis: false,
	isUnderlined: false,
	italic: false,
}

export default CallToActionDecorator(CSSModules(TextLink, styles, {allowMultiple: true}))
